import { useEffect, useState } from "react";

const images = [
    "/images/Home/Slider/1.jpg",
    "/images/Home/Slider/2.jpg",
    "/images/Home/Slider/3.jpg",
    "/images/Home/Slider/4.jpg",
    "/images/Home/Slider/5.jpg",
    "/images/Home/Slider/6.jpg",
    "/images/Home/Slider/7.jpg",
    "/images/Home/Slider/8.jpg",
    "/images/Home/Slider/9.jpg",
];

function WellnessSlider() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="relative py-20 bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 overflow-hidden">

            {/* ================= HEADING & INFO ================= */}
            <div className="text-center mb-12 px-4">
                <h1 className="text-3xl md:text-5xl font-bold text-white tracking-wide">
                    GAVLI HOSPITAL KURAWAR
                </h1>

                <p className="mt-3 text-white/90 text-base md:text-lg">
                    Ward No. 7, Near Bhopal–Biaora Highway, Kurawar,
                    District Rajgarh, Madhya Pradesh – 465667
                </p>

                <p className="mt-2 text-yellow-300 text-sm md:text-base italic">
                    Better Health • Better Tomorrow
                </p>
            </div>

            {/* ================= SLIDER ================= */}
            <div className="relative max-w-6xl mx-auto overflow-hidden">
                <div
                    className="flex transition-transform duration-700 ease-in-out"
                    style={{
                        transform: `translateX(-${current * 240}px)`,
                    }}
                >
                    {images.map((img, i) => (
                        <div key={i} className="min-w-[240px] mx-3">
                            <div className="rounded-2xl border-4 border-yellow-400 overflow-hidden shadow-xl">
                                <img
                                    src={img}
                                    alt="Gavli Hospital Facilities"
                                    className="w-full h-48 object-cover hover:scale-105 transition"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ================= DOTS ================= */}
            <div className="flex justify-center mt-8 gap-2">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setCurrent(i)}
                        className={`h-3 w-3 rounded-full transition ${current === i ? "bg-yellow-400" : "bg-gray-400"
                            }`}
                    />
                ))}
            </div>
        </section>
    );
}

export default WellnessSlider;
